import config from "@/config";
import http from "@/utils/request";

// 权限管理：管理员账号（迁移自 managesaas sass.js 的账号系列接口，URL 去掉历史 .html 后缀）
export default {
	user: {
		url: `${config.API_URL}/manage/member.Login/user`,
		name: "账号列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	del: {
		url: `${config.API_URL}/manage/member.Login/delete`,
		name: "删除账号",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	setStatus: {
		url: `${config.API_URL}/manage/member.Login/setStatus`,
		name: "更改账号状态",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	getRoleTree: {
		url: `${config.API_URL}/manage/member.Role/getRoleTree`,
		name: "角色下拉选项",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	add: {
		url: `${config.API_URL}/manage/member.Login/add`,
		name: "添加管理员账号",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
	edit: {
		url: `${config.API_URL}/manage/member.Login/edit`,
		name: "编辑管理员账号",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		},
	},
};
